var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contract-summary"},[_c('div',{staticClass:"contract-summary__title ms-help"},[_vm._v("\n    Итого по проекту\n  ")]),_c('i-table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.summary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }